import { Injectable } from '@angular/core';
import { ConstantConfigurationService } from '../../../shared/services/constant-configuration/constant-configuration.service';
import { of } from 'rxjs';
import { BackendService } from '../backend/backend.service';
import { SettingsService } from '../settings/settings.service';
// import { CandidateLanguageSelectionService } from '../candidate-language-selection/candidate-language-selection.service';
import { ExamListService } from '../exam-list/exam-list.service';
// import { LanguageService } from '../language/language.service';
import { QuestionBankService } from '../question-bank/question-bank.service';
import { CandidateListService } from '../candidate-list/candidate-list.service';

@Injectable({
    providedIn: 'root'
})
export class SearchService {


    private path = '/search';


    constructor(
        private constantService: ConstantConfigurationService,
        private backendService: BackendService,
        private questionBankService: QuestionBankService,
        // private candidateService: CandidateLanguageSelectionService,
        // private languageService: LanguageService,
        private examDashboardService: ExamListService,
        private candidateListService: CandidateListService,


    ) { }

    search(entity, term, meta) {


        // if (entity == "candidate") {
        //     return this.candidateService.searchCandidate(1, 10, { key: term });
        // }

        if (entity == "test_centers") {
            return this.candidateListService.searchTestCenters({ key: term });
        }



    }








    loadAll(entity, entityname, parent) {

        if (entity == "codeset") {
            return this.constantService.getConstantValue(entityname);
        }
        // else if (entity == "centername") {
        //     return this.examineeDetailsService.getExamName();
        // }
        else if (entity == "language") {
            return this.questionBankService.getLanguages();
        }
        else if (entity == "exam") {
            return this.examDashboardService.getExams();
        }





    }

}
